<template>
  <div id="welcome">
    <div style="background: #fff; overflow: hidden">
      <SearchQuery ref="search" objType='advancedSearch' :searchName='searchName' @change="getSearch"
        class="search-content" />
      <div style="height: 6px; background: #ebebeb"></div>
    </div>
    <!-- <search-table v-if="searchView"></search-table> -->
    <div v-loading='loading'>
      <search-table ref="tab" @changePagination="paginaSearch" :data="tableData" :elementHeight="elementHeight"
        :searchInfo="searchInfo"></search-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import TitleTag from "@/components/titleTag";
import SearchQuery from "./searchItem/search.vue";
import SearchTable from './searchItem/searchTable.vue';
export default {
  name: 'globalSearch',
  data() {
    return {
      searchName: "",
      searchView: false,
      tableData: [],
      selectGroup: [],
      select_value: "",
      elementHeight: 600,
      searchInfo: {},
      loading: false
    };
  },
  components: {
    SearchQuery,
    TitleTag,
    SearchTable
  },
  // props:['elementHeight'],
  // mounted(){} ,
  methods: {

    paginaSearch(e) {
      this.loading = true;
      let obj = this.$refs.search.getSearchInfo();
      obj.currentPage = e.currentPage;
      obj.pageSize = e.pageSize;
      // console.log(obj,e);

      this.searchShow = false;
      this.searchInfo = obj.seekVo;

      this.getSearch(obj);

      // this.loading = true;

      // axios.post("/search/advanced/search", obj).then((res) => {
      //   if (res.data.code == 200) {
      //     this.activeNames = [];
      //     this.tableData = res.data.object;
      //   } else {
      //     this.$message.error(res.data.message);
      //   }
      // });
    },


    getSearch(obj) {
      // this.showTable(res);
      // this.$refs.tab.turnLoading();
      this.loading = true

      axios.post("/search/advanced/search", obj).then((res) => {
        if (res.data.code == 200) {
          // this.$emit("change", { data: res.data, searchInfo: obj });
          this.searchInfo = obj.seekVo
          this.tableData = res.data.object;
          // console.log(this.tableData);
        } else {
          this.$message.error(res.data.message);
        }
      }).finally(_ => {
        this.loading = false;
      })
    },

    saveSearch() {
      if (this.$route.query.seekId) {
        let obj = this.$refs.search.getSearchInfo();
        obj.seekVo = {
          id: this.$route.query.seekId,
          name: this.searchName,
          isPublic: 0
        }
        axios.post("/search/advanced/saveSeek", obj).then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            this.$emit("deletePage");
          }
        });
      } else {
        this.$prompt(
          this.$t("message.tips.name"),
          this.$t("message.tips.tip"),
          {
            confirmButtonText: this.$t("message.button.affirm"),
            cancelButtonText: this.$t("message.button.cancel"),
            type: "warning",
          }
        )
          .then((e) => {
            //     console.log(e);(e);

            this.$store.commit("setPersonalSearch", {
              id: 0,
              name: e.value,
              type: 0,
            });
            var ifExistingInPersonalSearch =
              this.$store.getters.ifExistingInPersonalSearch;
            //     console.log(e);(ifExistingInPersonalSearch);
            if (ifExistingInPersonalSearch === 1) {
              //     console.log(e);(ifExistingInPersonalSearch);
              this.$message({
                message: this.$t("message.warning.alreadyInPersonalSearch"),
                type: "error",
              });
              return;
            }

            let obj = this.$refs.search.getSearchInfo();
            obj.seekVo.name = e.value;
            obj.seekVo.isPublic = 0;
            //     console.log(e);(obj);
            axios.post("/search/advanced/saveSeek", obj).then((res) => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.$emit("deletePage");
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: this.$t("message.tips.saveCancel"),
            });
          });
      }
    },
    deleteSearch() {
      //     console.log(e);(this.loadedSearch);
      if (!this.loadedSearch) return true;
      this.$confirm(
        this.$t("message.confirm.deleteSearch"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          axios
            .post("/pmdm/admin/criteria/deleteSeekById?seekId=" + this.$route.query.seekId)
            .then(res => {
              if (res.data.code == 200) {
                this.$message.success(res.data.message);
                this.$emit("deletePage");
              }
            })
            .catch(function (error) {
              ////     console.log(e);(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },



    getSearchSelect() {
      this.$http
        .get("/pmdm/admin/cls/getBaseClses")
        .then((res) => {
          let baseClass = res.data.object.baseClses;
          this.selectGroup = baseClass.map((i) => {
            return { label: i.name, value: i.id };
          });
          this.select_value = this.selectGroup[0].value;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async getTableInfo() {

      if (this.$route.query.seekId) {
        this.searchView = true;
        this.$http
          .get(
            "/search/advanced/getTableByTreeSearch?seekId=" +
            this.$route.query.seekId
          )
          .then((res) => {
            this.searchName = this.$route.query.seekName;
            this.tableData = res.data.object;
          });
        // return;
      }
    },

  },

  props: ["changeValue"],
  watch: {
    changeValue: function (value) {
      this.getTableInfo();
    },
  },
  mounted() {
    this.$refs.tab.turnLoading();
  },
  created() {
    this.getSearchSelect();
    // this.getTableInfo();
  },

};
</script>


<style scoped>
.pagination {
  margin-top: 15px;
  text-align: left;
}

.search-condition {
  border-left: 8px solid #3ea0fb;
  padding-left: 12px;
  margin-left: 10px;
}

.search-title {
  /* width: 120px; */
  padding-right: 120px;
  margin-left: 15px;
}

.search-content {
  margin: 10px 10px;
}

.btn {
  display: inline-block;
  padding: 3px;
  padding-right: 10px;
  border: 1px solid #000;
  border-radius: 3px;
  cursor: pointer;
  margin-left: 8px;
  font-size: 14px;
}

.btn i {
  display: inline-block;
  width: 18px;
  height: 18px;
  position: relative;
  top: 3px;
  font-size: 14px;
}

.btn img {
  height: 100%;
  width: 100%;
}

.btn6 {
  height: 32px;
  /* line-height: 32px; */
  color: #f5a521;
  border-color: rgba(245, 165, 33, 0.5);
  background: rgba(245, 165, 33, 0.2);
  margin: 0;
  position: relative;
  /* top: 2px; */
}

.btn6:hover {
  color: #fff;
  background: rgba(245, 165, 33, 0.4);
}

.el-selector-search {
  width: 18px;
}
</style>